import { SessionHistory } from './SessionHistory'
import { withSessionHistory } from './withSessionHistory'

const ConnectedSessionHistory = withSessionHistory(SessionHistory)
export { ConnectedSessionHistory as SessionHistory }
